<template>
    <div>
        <h1 style="font-size: 24px; color: black;">全屏视频/激励视频方案</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showSaveFormDialog('新增应用')">新增应用</el-button>
            </el-col>
        </el-row>
        <el-col :span="10">
            <span>渠道</span>
            <el-cascader v-model="queryData.subChannels" :options="subChannels" :props="optionProps" clearable
                         collapse-tags>
            </el-cascader>
            <span>app应用</span>
            <el-select v-model="queryData.appIds" placeholder="请选择" multiple>
                <el-option
                    v-for="item in apps"
                    :key="item.appId"
                    :label="item.appName"
                    :value="item.appId">
                </el-option>
            </el-select>
        </el-col>
        <el-button type="primary" @click="getList">查询</el-button>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号" align="center"></el-table-column>
                <el-table-column prop="appId" label="应用" align="center" :formatter="appFormatter"></el-table-column>
                <el-table-column label="渠道" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.subChannels.length === 0 ? "" : scope.row.subChannels.join(",") }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑配置',scope.row)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px">
            <el-form :model="saveForm">
                <el-form-item label="应用名称" :label-width="labelWidth">
                    <el-select v-model="saveForm.appId">
                        <el-option
                            v-for="item in apps"
                            :key="item.appId"
                            :label="item.appName"
                            :value="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道" :label-width="labelWidth">
                    <el-cascader v-model="saveForm.subChannels" :options="subChannels" :props="optionProps" clearable
                                 collapse-tags>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="最大ecpm" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.max"></el-input>
                </el-form-item>
                <el-form-item label="最小ecpm" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.min"></el-input>
                </el-form-item>
                <el-form-item label="用户类型" :label-width="labelWidth">
                    <el-select v-model="saveForm.userType" clearable placeholder="请选择"
                               :formatter="userTypeFormatter">
                        <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="间隔时长" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.intervalSeconds"></el-input>
                </el-form-item>
                <el-form-item label="每日展示上限" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.maxPop"></el-input>
                </el-form-item>
                <el-form-item label="广告类型选择" :label-width="labelWidth">
                    <el-select v-model="saveForm.adt" clearable placeholder="请选择" :formatter="adtFormatter">
                        <el-option v-for="item in adtType" :label="item.name" :key="item.id"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="触发方式选择" :label-width="labelWidth">
                    <el-select v-model="saveForm.popType" clearable placeholder="请选择" :formatter="popTypeFormatter">
                        <el-option v-for="item in popTypes" :label="item.name" :key="item.id"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="倒计时提示秒" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.countdownSeconds"></el-input>
                </el-form-item>
                <el-form-item label="备注" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {appAll, channelList, removeAdPopId, saveAdPopId, searchAPopId} from '@/http/api'
import app from "@/App.vue";

export default {
    name: "AdId",
    computed: {
        app() {
            return app
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '110px',
            list: [],
            subChannels: [],
            apps: [],
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            users: [{id: 0, name: '全部'},
                {id: 1, name: '新用户'},
                {id: 2, name: '老用户'}],
            adtType: [{id: 0, name: '全屏视频（插屏全屏视频）'}],
            popTypes: [{id: 0, name: '强行'},
                {id: 1, name: '误点'},
                {id: 2, name: '常规'}],
            saveForm: {
                id: null,
                appId: null,
                subChannels: [],
                max: null,
                min: null,
                userType: null,
                intervalSeconds: null,
                maxPop: null,
                adt: null,
                popType: null,
                countdownSeconds: null,
                remark: null
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {},
        }
    },
    methods: {
        appFormatter: function (row, column, cellValue) {
            let temp = ""
            this.apps.forEach(item => {
                if (item.appId === cellValue) {
                    temp = item.appName;
                }
            })
            return temp
        },
        userTypeFormatter: function (row, column, cellValue) {
            let temp = ""
            this.users.forEach(item => {
                if (item.userType === cellValue) {
                    temp = item.name;
                }
            })
            return temp
        },
        adtFormatter: function (row, column, cellValue) {
            let temp = ""
            this.adtType.forEach(item => {
                if (item.id === cellValue) {
                    temp = item.name;
                }
            })
            return temp
        },
        popTypeFormatter: function (row, column, cellValue) {
            let temp = ""
            this.popTypes.forEach(item => {
                if (item.id === cellValue) {
                    temp = item.name;
                }
            })
            return temp
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.getList();
        },
        getList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchAPopId(this.queryData).then(resp => {
                this.list = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        remove(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeAdPopId(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.getList();
                    }
                });
            }).catch(() => {
            })
        },
        showSaveFormDialog(_title, _data) {
            this.dialogVisible = true;
            this.dialogTitle = _title;
            this.saveForm = {
                id: null,
                appId: null,
                subChannels: [],
                max: null,
                min: null,
                userType: null,
                intervalSeconds: null,
                maxPop: null,
                adt: null,
                popType: null,
                countdownSeconds: null,
                remark: null
            };
            if (_data) {
                this.saveForm = {
                    id: _data.id,
                    appId: _data.appId,
                    subChannels: _data.subChannels,
                    max: _data.max,
                    min: _data.min,
                    userType: _data.userType,
                    intervalSeconds: _data.intervalSeconds,
                    maxPop: _data.maxPop,
                    adt: _data.adt,
                    popType: _data.popType,
                    countdownSeconds: _data.countdownSeconds,
                    remark: _data.remark
                }
            }
        },
        confirmForm() {
            let _message = '';
            if (this.saveForm.subChannels.length < 1) {
                _message = '渠道必选'
            } else if (this.saveForm.appId === null) {
                _message = '应用必选'
            } else if (this.saveForm.remark === null) {
                _message = '备注必填'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            saveAdPopId(this.saveForm).then(resp => {
                if (resp.data.status === 0) {
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }

    },
    created() {
        this.getList();
        let _this = this;
        channelList().then(resp => {
            this.subChannels = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.subChannels.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
            });
            appAll().then(resp => {
                this.apps = resp.data.info;
            });
        });
    }
}
</script>

<style scoped>

</style>
